{
	"titles": {
		"flagSingle": "Flag incorrect carbon allocation",
		"resolveSingle": "Carbon allocation resolved for transaction?",
		"flagMultiple": "Flag incorrect carbon allocation for all filtered transactions",
		"resolveMultiple": "Carbon allocation resolved for multiple transactions?"
	},
	"flagSingle": {
		"description1": "Please provide a detailed explanation for the incorrect amount of carbon savings allocated to this transaction.",
		"description2": "Your feedback will be reviewed by Heidelberg Materials and, if necessary, the allocation will be corrected using the buffer savings.",
		"explanationPlaceholder": "Please add your explanation"
	},
	"resolveSingle": {
		"confirmationLabel": "The transaction has been reviewed. Any required corrective measures have been taken and are confirmed to have been aligned with the auditor.",
		"explanationPlaceholder": "Please add your explanation",
		"uploadDescription": "Optionally, you can attach a document related to the carbon balance correction.",
		"uploadHint": "PDF, XLS, XLSX, XML, CSV, DOCX"
	},
	"flagMultiple": {
		"description1": "Please indicate in which of the filtered transactions you have detected incorrect carbon allocation and provide a detailed explanation of these discrepancies.",
		"description2": "Your feedback will be reviewed by Heidelberg Materials and, if necessary, the allocation will be adjusted using buffer savings.",
		"explanationPlaceholder": "Please add your explanation"
	},
	"resolveMultiple": {
		"confirmationLabel": "All transactions have been reviewed. Any required corrective measures have been taken and are confirmed to have been aligned with the auditor.",
		"explanationPlaceholder": "Please add your explanation",
		"uploadDescription": "(optional) You can attach a document related to the carbon balance correction.",
		"uploadHint": "PDF, XLS, XLSX, XML, CSV, DOCX"
	},
	"errors": {
		"commentRequired": "Please add your explanation",
		"confirmationRequired": "Please confirm all transactions have been reviewed",
		"maxFilesExceeded": "You can upload a maximum of {{count}} documents",
		"unsupportedFileType": "Unsupported file format. Allowed formats: PDF, XLS, XLSX, XML, CSV, DOCX"
	},
	"actionButtons": {
		"cancel": "Cancel",
		"flagSingle": "Flag incorrect allocation",
		"resolveSingle": "Mark transaction as resolved",
		"flagMultiple": "Flag incorrect allocations",
		"resolveMultiple": "Mark transactions as resolved"
	},
	"toasts": {
		"flagSingle": "The transaction status has been changed to flagged.",
		"resolveSingle": "The transaction status has been changed to resolved.",
		"flagMultiple": "The status of the transactions has been changed to flagged.",
		"resolveMultiple": "The status of the transactions has been changed to resolved.",
		"error": "Something went wrong. Please try again."
	}
}
